// Login field redirect script
// Detects "KanEquip" in username field and redirects to KanEquip portal
//alert('hello world');
(function() {
    'use strict';

    // Each entry: target host fragment (skip if already there), redirect URL, and keywords (case-insensitive)
    var redirectRules = [
        {
            hostFragment: 'kanequip.primus-software.com',
            redirectUrl: 'https://kanequip.primus-software.com',
            keywords: ['kanequip', 'modernaginc', 'flinthillsequipment'] //this also takes care of 'kanequip.com', '@modernaginc.com', etc.
        },
        {
            hostFragment: 'forresterfarm.primus-software.com',
            redirectUrl: 'https://forresterfarm.primus-software.com',
            keywords: ['ffe.com', 'forresterfarmeq', 'agindustrial']
        }
    ];

    // Wait for DOM to be fully loaded
    function initializeRedirect() {
        var hostname = window.location.hostname.toLowerCase();

        // Only run on primus-software.com (comment out to test on localhost)
        if (hostname.indexOf('primus-software.com') === -1)
            return;

        // Skip if already on any configured target host
        var alreadyOnTarget = redirectRules.some(function (rule) {
            return hostname.indexOf(rule.hostFragment.toLowerCase()) !== -1;
        });
        if (alreadyOnTarget)
            return;

        var loginField = document.querySelector('[id*="UserName_Edit_I"]');

        if (!loginField) {
            console.warn('Login field not found. Retrying...');
            setTimeout(initializeRedirect, 500);
            return;
        }

        loginField.addEventListener('blur', function () {
            var fieldValue = this.value.trim();

            var domainPart = fieldValue.indexOf('@') !== -1
                ? fieldValue.split('@')[1].toLowerCase()
                : fieldValue.toLowerCase();

            for (var i = 0; i < redirectRules.length; i++) {
                var rule = redirectRules[i];
                var matched = rule.keywords.some(function (keyword) {
                    return domainPart.indexOf(keyword.toLowerCase()) !== -1;
                });

                if (matched) {
                    window.location.href = rule.redirectUrl;
                    return;
                }
            }
        });

        console.log('Login redirect script initialized successfully');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeRedirect);
    } else {
        initializeRedirect();
    }
})();